module.exports = __webpack_public_path__ + "img/info-top-bg.26fae4db.jpg";